module.exports = __webpack_public_path__ + "static/VetCode_1-de8b7c51fa629aebcea58d8a65d5789c.png";